import actions from '../utils/restActions';
import { customRequest} from '../utils/restUtils';

export const loadPages = () => {
    return (dispatch) => {
	return customRequest(actions.pages.index, {}).then((res) => {
	    return dispatch({ type: actions.pages.index.status.success, data: res});
	})
    }
}

export const savePage = (data) => {
    return (dispatch) => {		   
	return customRequest(actions.pages.create, {page: data})
    }
}

export const updatePage = (data) => {
    return (dispatch) => {		   
	return customRequest(actions.pages.update, {id: data.id, page: data})
    }
}


export const removePage = (data) => {
    return (dispatch) => {		   
	return customRequest(actions.pages.delete, data)
    }
}





// WEBPACK FOOTER //
// ./src/actions/Pages.js